<template>
  <div>
    <!-- <naj-alert
      v-if="showJudgementDeliveryDateNote && judgments && judgments.length > 0"
      type="information"
    >
      <template slot="content">
        {{ local.caseFile.noJudgementLine1 }}{{ local.caseFile.noJudgementLine2 }}{{ toHijriDate(nearestDeliveryDate) }}{{ local.caseFile.hijri }}
      </template>
    </naj-alert> -->
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.judgements }}
        </div>
        <v-row class="mx-12">
          <template v-for="(item, index) in judgments">
            <v-col
              :key="index"
              cols="4"
            >
              <judgement-card
                :judgement="item"
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
                @judgement-card-click="openJudgementInfo(item)"
              ></judgement-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data
              :has-data="judgments && judgments.length > 0"
              :loading="loading"
              :no-data-message="local.caseFile.noJudgementsOnThisCase"
            ></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <degree-color-palette></degree-color-palette>

    <pdf-judgements-modal
      :judgements="judgments"
      :selected-judgement-index-prop="selectedJudgementIndex"
      :modal-visibility="showJudgementInfoModal"
      @modalClose="closeJudgementInfo"
    ></pdf-judgements-modal>

    <naj-alert-modal
      :show-modal="showAlertModal"
      type="information"
      :title="local.caseFile.secretJudgementsInfoTitle"
      :message="local.caseFile.secretJudgementsInfo"
      @onCancelModal="showAlertModal=false"
    >
    </naj-alert-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import JudgementCard from '@/modules/global/components/cards/judgement-card.vue';
import PdfJudgementsModal from '@/modules/cases/pdf-judgements-modal';
const { mapActions } = createNamespacedHelpers('CasesModule');
import DegreeColorPalette from '../../../../case-file/degree-color-palette/index.vue';
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'CaseJudgmentsTab',
  components: {
    JudgementCard,
    PdfJudgementsModal,
    DegreeColorPalette,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    requestObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
    isSecretJudgements: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      judgments: [],
      loading: false,
      selectedJudgementIndex: 0,
      showJudgementInfoModal: false,
      showAlertModal: false,
      futureDeliveryDate: String,
    };
  },
  computed: {
    nearestDeliveryDate() { return this.futureDeliveryDate; },
    showJudgementDeliveryDateNote() {
      return (this.futureDeliveryDate !== undefined && this.futureDeliveryDate !== null && this.futureDeliveryDate !== '');
    },
  },
  mounted() {
    this.loadData();
    //this.getNearestDeliveryDate();
  },
  methods: {
    ...mapActions([
      'getJudgementsByRequestObjectKey', 'getNearestJudgement',
    ]),
    loadData() {
      this.loading = true;
      this.getJudgementsByRequestObjectKey(this.requestObjectKey)
        .then((res) => {
          this.judgments = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
    openJudgementInfo(judgement) {
      if (this.isSecretJudgements) {
        this.showAlertModal = true;
      } else {
        this.showJudgementInfoModal = true;
        this.selectedJudgementIndex = this.judgments.findIndex(a => a.id == judgement.id);
      }
    },
    closeJudgementInfo() {
      this.showJudgementInfoModal = false;
      this.selectedJudgementIndex = 0;
    },
    toHijriDate,
    getNearestDeliveryDate() {
      var objectKey = this.$route.params.caseObjectKey;
      this.getNearestJudgement(objectKey)
        .then(({ data }) => {
          this.futureDeliveryDate = data;
        });
    },
  },
};

</script>

<style lang="scss" scoped>
</style>